import { useNavigate } from "react-router-dom";
import { useSpace } from "../../../../hooks/useSpace";
import type { SubTopicDatabase } from "../../../../types";
import { useDeleteSubTopic } from "../../api/useDeleteSubTopic";

type Props = {
  subTopic: SubTopicDatabase;
};

export function useDeleteSubTopicModal(props: Props) {
  const { mutateAsync } = useDeleteSubTopic();
  const navigate = useNavigate();
  const { currentSpace } = useSpace();

  async function handleConfirm() {
    await mutateAsync(props.subTopic.id);
    navigate(`/spaces/${currentSpace?.slug}`);
  }

  return { handleConfirm };
}
